module.exports = __webpack_public_path__ + "img/9353c3f.png";